import MergedImagesWrapper from "./MergedImagesWrapper";
import WesternBlotSvgImage from "./WesternBlotSvgImage";
import SvgMergedImage from "./SvgMergedImage";
import { useState } from 'react';
import G from './Getters';
import imageMap from './imageMap';
import { ANNOTATIONS } from './RecordTypes';
//import SvgImageFilter, { computeFilterArgs } from './NewSvgImageFilter';
import SvgImageFilter, { computeFilterArgs } from './SvgImageFilter';
import computeFilters from './computeFilters';
import MergedImages from './MergedImages';
import { useStore } from 'react-redux';
import { layersByChannelIdToLayers } from "./utils";

const TRACE = false;

function ErrorText({x,y,width,height,text,onClick,}){


  return (
    <>
      <rect {...{x,y,width,height,fill:"pink"}}/>
    <text id="error-text" x={x+width/2}y={y+1.15 * height/2} width={width} 
    onClick={e => onClick && onClick(e)}
    height={height} 
    fontSize={12}
    dominantBaseline={"middle"}
    textAnchor={"middle"}
    fill="black">
    {text}</text>
    </>
  )

}

function getCropArgs(state,{node,value}){


  let toReturn;

  if( node ){

    if( !node.value ){
      return {};
    }

    let regionId = node.value.regionId;
    let annotationId = value.value.regions[regionId];
    toReturn = {
      imageId:Object.values(node.value.layersByChannelId).find(x => x.imageId)?.imageId,
      annotationId,
    }

  }else if( value.value.annotationId ){
    let annotationId = value.value.annotationId;
    toReturn = {
      annotationId,
      imageId:G.getImageSetFigureImageIdByAnnotationId(state,{annotationId})
    }
  }

  if( !toReturn.annotationId ){
  }

  return toReturn;
  

}

function getCrop(state,{node,value}){


}


export default function SvgImage(svgImageArgs){

  let {state, value, bounds, div,cell, imageUrlMap, exportId, nodeId,onClick, node, figurePanel, download } = svgImageArgs;
  

  if( !node ){
    return (
      <WesternBlotSvgImage {...svgImageArgs}/>
    )

  }
 
  let layers = layersByChannelIdToLayers(node?.value?.layersByChannelId ?? {});

  




  let {width, height, x, y} = bounds;


  let {annotationId,imageId} = getCropArgs(state,{node, value})

  if( !annotationId ){
    return (
      <>


      <ErrorText {...{
      x,y,width,height,
      text:"?"
    }}/>
      </>

    )
  }
  

  let atnRecord = G.getRecord(state,{type:ANNOTATIONS,_id:annotationId});
  let { meta } = atnRecord
  if( meta.archived ){
    return <ErrorText {...{
      x,y,width,height,
      text:"Annotation Deleted"
    }}/>
  }


  if( !imageId ){


    let {annotationId,imageId} = getCropArgs(state,{node, value})


    return (
      <text {...{
        x,y,
      }}>NO IMAGE ID</text>
    )
  }
  
  let crop = G.getCropFromAnnotation(state,{
    annotationId,
    imageId,
  });

  let { imageSetId } = crop;




  //let imageId = crop.imageId || state.data.imageSets[crop.imageSetId].figureImageId;




  let imageSet = state.data.imageSets[ imageSetId ];
  let angle = !isNaN(crop.rotation) ? crop.rotation : imageSet.rotation;
  let imageRecord = state.data.imageUploads[ imageId ];



  let divId = [
    (div.id || nodeId),
    cell?.join('_')
  ].filter(x => x).join('-cell-');

  //let imageHeight = imageRecord.height;
  let url = imageRecord.url;

  let colorProjection = layers.filter(x => x.color && x.imageId).map(x => x.color);
  console.log('$cp', colorProjection);


  if( cell?.[0] === 3 ){
    debugger;
  }


  let imgStyle = {height:crop.height * width, width, }
  let clipId = 'clip-'+divId;
  let filterId = 'sciugo-adjustments-'+divId+'_'+exportId;


  let href = (imageUrlMap && imageUrlMap[imageId]) || (
    imageMap[url] || url
  )

  if( !href ){
    return <ErrorText {...{
      onClick,
      x,y,width,height,
      text:imageId//"Image not found."
    }}/>
  }

  let zoom = (value.imageAdjustments && value.imageAdjustments.zoom) || 1;
  let [deltaX,deltaY] = (
    value.imageAdjustments && value.imageAdjustments.positionDelta
  ) || [0,0];


  let imageX = x - crop.left * width / crop.width * zoom + deltaX;

  let translateY = - crop.top * width / crop.width * zoom + deltaY;

  let imageY = y + translateY;

  let imageWidth = width / crop.width * zoom;
  let imageHeight = width / crop.width * zoom * imageRecord.height;


  let defaultHeight = width * imageRecord.height;

  let rotationOriginX = zoom * width / crop.width /2;
  let rotationOriginY = zoom * defaultHeight / crop.width /2;

  let rotate = "rotate("+-angle+","+rotationOriginX+","+rotationOriginY+") ";



  let trX = -crop.left * zoom * width / crop.width + deltaX /// crop.width;
  let trY = -crop.top * zoom * width / crop.width + deltaY;
  let translate = "translate("+trX+","+trY+")";
  let scale = ""//"scale("+1/crop.width+")"

  let transform = scale + " " + translate + " " + rotate;

  const dim = {
    x:0,
    y:0,
    width:zoom * width / crop.width ,
    height:zoom * defaultHeight / crop.width
  }

  const adjustments = figurePanel?.globalStyle?.channelAdjustments ?? {};

  console.log("SVG IMAGE WAS PLACED!");

  let leaderLines = Array.from(document.querySelectorAll(`[nodeId="${nodeId}"][item=leader-line]`)).map(el => {

    let computedStyle = window.getComputedStyle(el);

    return Object.fromEntries((["x1","x2","y1","y2","stroke","strokeWidth"].map(prop => [prop,
      computedStyle[prop] || el.getAttribute(prop)
    ])))
  }) 

  let path = Array.from(document.querySelectorAll(`[nodeId="${nodeId}"] [objecttype=annotationCropBox]`)).map(el => {


    let computedStyle = window.getComputedStyle(el);


    return Object.fromEntries((["stroke","strokeWidth","fill","stroke-dasharray","shape-rendering","d"].map(prop => [prop,
     el.getAttribute(prop) || computedStyle[prop] 
    //el.getAttribute(prop)
  ])))
  })

  let scalebarText =  Array.from(
    document.querySelectorAll(
      `[nodeId="${nodeId}"] [component=scalebar] [item=text]`
    )).map(el => {

      let nodeBounds = document.querySelector(`[nodeId=${nodeId}]`).getBoundingClientRect();
      let refX = nodeBounds.x;
      let refY = nodeBounds.y;
      

      let bounds = el.getBoundingClientRect();

      let thisBounds = el.getBoundingClientRect();

      let computedStyle = window.getComputedStyle(el);

      return { 
        x:(thisBounds.x - refX), 
        y:(thisBounds.y - refY), 
        width:thisBounds.width, height:thisBounds.height,
        
        //stroke:(el.getAttribute("color") || "white"),
        fontSize:(el.getAttribute("font-size") || 12),
        dominantBaseline:"hanging",
        //strokeWidth:1,
        fill:(computedStyle["color"] || "white"),
        fontWeight:computedStyle['font-weight'],
        children:el.innerText,
        fontFamily:computedStyle.fontFamily || computedStyle['font-family'],
      };
    })


  let scalebarLines =  Array.from(
    document.querySelectorAll(
      `[nodeId="${nodeId}"] [component=scalebar] [item=scalebar-line]`
    )).map(el => {

      let computedStyle = window.getComputedStyle(el);

      let nodeBounds = document.querySelector(`[nodeId=${nodeId}]`).getBoundingClientRect();
      let refX = nodeBounds.x;
      let refY = nodeBounds.y;
      

      let thisBounds = el.getBoundingClientRect();
      return { 
        x:(thisBounds.x - refX), y: (thisBounds.y - refY), width:thisBounds.width, 
        height:thisBounds.height,
        //stroke:"white",
        //strokeWidth:1,
        fill:computedStyle["background-color"],
      };
    })


    return (
      <>
        <svg 

          colorInterpolationFilters={"sRGB"}
          x={x} y={y} width={width} height={height}
          //stroke={"white"}
          //strokeWidth={1}

          style={{
            //background:'white',
            //overflow:'visible',
            //border:'3px solid white',
          }}>

          <svg x={0} y={0} width={width} height={height} className="merged-save-container">
            <MergedImagesWrapper toDraw={layers} adjustmentProp={adjustments} annotationId={annotationId} width={width} height={height} imageUrlMap={imageUrlMap} download={download} />
          </svg>

          {leaderLines.map((props,ii) => ii%2===0 && <line id="LEADER" {...{...props}}/>)}
          {path.map(props => <path id="REGION-OUTLINE" {...{...props}}/>)}
          {scalebarText.map(props => <text {...{...props}}/>)}
          {scalebarLines.map(props => <rect {...{...props}}/>)}
        </svg>

        {TRACE && <text x={x} y={y} stroke="yellow" height="15">{JSON.stringify([trX,trY])}</text>}
        {TRACE && <circle cx={x} cy={y} r={3} fill="magenta"/>}
        {TRACE && <rect stroke="lime" strokeWidth={3} 
          x={imageX} y={imageY} 
          width={imageWidth} height={imageHeight} fill={"none"}/>}
        {TRACE && <rect stroke="red" strokeWidth={1} x={x} y={y} width={width} height={height} fill={"none"}/>}
      </>
    )
}
